import workspaceQuery from '../../../graphql/queries/system/RegisteredDeviceWorkspaceQuery.graphql';
import instanceQuery from '../../../graphql/queries/system/RegisteredDeviceQuery.graphql';
import mutationQuery from '../../../graphql/mutations/system/RegisteredDeviceMutation.graphql';
import fragment from '../../../graphql/fragments/system/RegisteredDeviceFragment.graphql';
import defaultQuery from '../../../graphql/queries/system/RegisteredDeviceDefault.graphql';
import listQuery from '../../../graphql/queries/system/RegisteredDeviceListQuery.graphql';
import { EntityType } from '../../../@types/entityTypes';

const RegisteredDevice: EntityType = {
  type: 'RegisteredDevice',
  title: 'Registered Devices',
  formTitle: 'Registered Device',
  formUrl: '/System/RegisteredDevice/Details/',
  workspaceUrl: '/System/RegisteredDevice/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  update: mutationQuery,
  default: defaultQuery,
  fragment,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'name',
  },
  screenReference: 'REGISTERED_DEVICE',
};

export default RegisteredDevice;
